import { useQuery } from '@tanstack/react-query';
import { useClient } from './useClient';
import { ChannelsResponse } from '@hud/slack-dtos/api';

export const SLACK_CHANNELS_KEY = 'SlackChannels';

export default function useSlackChannels() {
  const { client, isReady } = useClient();
  return useQuery({
    queryKey: [SLACK_CHANNELS_KEY],
    queryFn: async () => {
      const response = await client.get<ChannelsResponse>('/slack/channels');
      return ChannelsResponse.parse(response.data);
    },
    enabled: isReady,
  });
}
